var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutgoingVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_774_6314",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_774_6314)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.26523 18.975C3.61523 19.325 4.04273 19.5 4.54773 19.5H15.9325C16.4375 19.5 16.865 19.325 17.215 18.975C17.565 18.625 17.74 18.1974 17.74 17.6923V13.1152L20.4862 15.8615C20.6337 16.009 20.7994 16.0458 20.9832 15.972C21.1672 15.8983 21.2592 15.7577 21.2592 15.55V8.45C21.2592 8.24233 21.1672 8.10167 20.9832 8.028C20.7994 7.95417 20.6337 7.991 20.4862 8.1385L17.74 10.8848V6.30775C17.74 5.80258 17.565 5.375 17.215 5.025C16.865 4.675 16.4375 4.5 15.9325 4.5H4.54773C4.04273 4.5 3.61523 4.675 3.26523 5.025C2.91523 5.375 2.74023 5.80258 2.74023 6.30775V17.6923C2.74023 18.1974 2.91523 18.625 3.26523 18.975ZM8.72461 9.49999H10.9209L6.21686 14.2037C6.07203 14.3487 5.99961 14.5244 5.99961 14.7307C5.99961 14.9372 6.07203 15.1129 6.21686 15.2577C6.36169 15.4026 6.53894 15.4734 6.74861 15.4702C6.95828 15.4671 7.13236 15.3962 7.27086 15.2577L11.9746 10.5537V12.75C11.9746 12.9625 12.0464 13.1407 12.1901 13.2845C12.3336 13.4282 12.5117 13.5 12.7244 13.5C12.9369 13.5 13.115 13.4282 13.2589 13.2845C13.4027 13.1407 13.4746 12.9625 13.4746 12.75V8.90373C13.4746 8.64773 13.3879 8.43315 13.2146 8.25998C13.0414 8.08665 12.8269 7.99999 12.5709 7.99999H8.72461C8.51211 7.99999 8.33394 8.07182 8.19011 8.21549C8.04644 8.35898 7.97461 8.53707 7.97461 8.74973C7.97461 8.96223 8.04644 9.1404 8.19011 9.28424C8.33394 9.42807 8.51211 9.49999 8.72461 9.49999Z",
    fill: "#141414"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutgoingVideo);
export default __webpack_public_path__ + "static/media/outgoing_video.5381c4a37cb744fc30a7b0ad149fe679.svg";
export { ForwardRef as ReactComponent };